import { Box, Typography } from '@mui/material';
import { WidgetWrapper } from '../WidgetWrapper';
import { StateLabelBox } from '../StateLabelBox';
import { valveWrapper, svgBox, modeBox, modeTitle, modeValue } from './style';
import { ValveAsset } from 'src/types/assets';
import { ValveWidget } from 'src/assets/widgets/ValveWidget';
import { usePumpStateAndMode } from 'src/hooks/featureHooks/usePumpStateAndMode';
import { useAssetStateData } from 'src/features/sites/hooks';
import { useAssetModeData } from 'src/features/sites/hooks/useAssetModeData';

type Props = {
  widgetId: string;
  title: string;
  asset: ValveAsset;
  toggleAddOrRemoveHandler?: () => void;
  isEditMode?: boolean;
  testId?: string;
  isLoading: boolean;
};

export const Valve = ({
  title,
  asset,
  toggleAddOrRemoveHandler,
  widgetId,
  testId,
  isEditMode,
  isLoading,
}: Props) => {
  const { assetState: liveActiveState } = useAssetStateData({ asset: asset! });
  const { assetMode: liveAssetMode } = useAssetModeData({ asset: asset });
  const { activeState, activeMode } = usePumpStateAndMode({ asset: asset });

  const displayState = liveActiveState ? liveActiveState : activeState;
  const displayMode = liveAssetMode ? liveAssetMode : activeMode;

  return (
    <WidgetWrapper
      title={title}
      isEditMode={isEditMode}
      widgetId={widgetId!}
      toggleAddOrRemoveHandler={toggleAddOrRemoveHandler}
      testId={testId}
      isDataReady={!isLoading}
      isValveWidget={true}
      assetPriority={asset?.priority}
    >
      <Box sx={valveWrapper}>
        <Box sx={svgBox}>
          <ValveWidget />
        </Box>
        {displayState ? <StateLabelBox text={displayState} /> : <Typography>-</Typography>}
        <Box sx={modeBox}>
          <Typography sx={modeTitle}>Mode:</Typography>
          <Typography sx={modeValue}>{displayMode ?? '-'}</Typography>
        </Box>
      </Box>
    </WidgetWrapper>
  );
};
